import { createApi } from '@shared/redux/createApi';

const tags = {
  getBinanceBrokerInfo: 'getBinanceBrokerInfo',
};

export const binanceBrokerApi = createApi({
  reducerPath: 'binanceBrokerApi',
  tagTypes: [tags.getBinanceBrokerInfo],

  endpoints: (builder) => ({
    getBinanceBrokerInfo: builder.query({
      query: () => {
        return ({
          method: 'get', url: `/admin/binance/broker-info`,
        });
      },
      providesTags: [tags.getBinanceBrokerInfo],
    }),
  }),
});

export const { useGetBinanceBrokerInfoQuery } = binanceBrokerApi;
